const ACTIONS = {
  ON_THE_WAY: 'ON_THE_WAY',
  DELAYED: 'DELAYED',
  DELIVERED: 'DELIVERED',
  PICKUP: 'PICKUP',
  SEPARATOR: 'SEPARATOR',
  LAUNCH_OFFER: 'LAUNCH_OFFER',
  FINISH_COST_NEGOTIATION: 'FINISH_COST_NEGOTIATION',
  CLOSE_AUCTIONS: 'CLOSE_AUCTIONS',
  NO_AVAILABLE_ACTIONS: 'NO_AVAILABLE_ACTIONS',
};

export default ACTIONS;
